import axios from 'axios';
import type { RouteRecordNormalized } from 'vue-router';
import { UserState } from '@/store/modules/user/types';

export interface LoginData {
  username: string;
  password: string;
}

export interface LoginRes {
  token: string;
}
// 登录接口-已对接完成
export function login(data: LoginData) {
  return axios.post<LoginRes>('/auth/login', data);
}
// 登出接口-已对接完成
export function logout() {
  return axios.get<LoginRes>('/auth/logout');
}
// 查询用户信息接口-已对接完成
export function getUserInfo() {
  return axios.get<UserState>('/auth/info');
}

// 菜单写死即可
export function getMenuList() {
  return axios.post<RouteRecordNormalized[]>('/api/user/menu');
}
